exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro{height:100vh;position:relative}.intro .intro-content{text-align:center;position:absolute}.intro .overlay-itro{position:absolute;top:0;left:0;padding:0;height:100%;width:100%}.display-table{width:100%;height:100%;display:table}.table-cell{display:table-cell;vertical-align:middle;transform:translateY(-10%)}.heading-primary-main{font-weight:600;font-size:3rem;animation-name:moveInleft;animation-duration:2s;color:#000;font-family:comfortaa;margin-top:0}.heading-primary-sub{font-size:1.5rem;font-weight:300;font-family:Arial;margin-top:10px;animation-name:moveInright;animation-duration:2s;color:#000}@keyframes moveInleft{0%{opacity:0;transform:translateX(-20px)}to{opacity:1;transform:translate(0)}}@keyframes moveInright{0%{opacity:0;transform:translateX(20px)}to{opacity:1;transform:translate(0)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53c86822","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 273
// module chunks = 0